import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';

//import components
import ItemText from './ItemText.js';

const ItemSubSectionSeparate = ({ clang, desc, items }) => {
    return (
        <div className="item__subsection--separate">
            {desc && desc.values &&
                <div>
                    <div className="item__subsection">
                        <label className="item__subsection-label">
                            <span className="item__subsection-label__inner">{lang[clang].item.item_type[desc.type]}</span>:
                        </label>
                        <div className="item__subsection-content">
                            <ItemText text={desc.values}/>
                        </div>
                    </div>
                    {items && items.length > 0 &&
                        <div className="item__subsection">
                            <label className="item__subsection-label">
                            </label>
                            <div className="item__subsection-content__separator">
                            </div>
                        </div>}
                </div>}
            {items && items.map((listItem, listItemIndex) =>
                <div key={listItemIndex}>
                    {listItem.filter(elem => elem.values && elem.values.length > 0).map((elem, listItemIndex) =>
                        <div key={listItemIndex} className="item__subsection">
                            <label className="item__subsection-label">
                                <span className="item__subsection-label__inner">{lang[clang].item.item_type[elem.type]}</span>:
                            </label>
                                <div className="item__subsection-content">
                                  {elem.values.map((arrItem, arrItemIndex) =>
                                      arrItemIndex !== elem.values.length - 1 ?
                                      <div className="item__subsection-content--inner" key={arrItemIndex}>
                                        <ItemText
                                          text={`${arrItem.label}`}
                                          link={arrItem.link}
                                          type={arrItem.entityType}/>
                                        <span>,</span>
                                      </div>
                                      :
                                      <div className="item__subsection-content--inner" key={arrItemIndex}>
                                          <ItemText
                                            text={arrItem.label}
                                            link={arrItem.link}
                                            type={arrItem.entityType}/>
                                      </div>)}
                                </div>
                        </div>)}
                    {listItemIndex !== items.length - 1 &&
                        <div className="item__subsection">
                            <label className="item__subsection-label__separator">
                            </label>
                            <div className="item__subsection-content">
                            </div>
                        </div>}
                </div>)}
        </div>
    );
};

ItemSubSectionSeparate.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemSubSectionSeparate);



// WEBPACK FOOTER //
// ./src/components/items/ItemSubSectionSeparate.js